import { HttpInterceptorFn } from '@angular/common/http';
import { inject, untracked } from '@angular/core';
import { isApiRequest } from '../../data/http/api-envelope';
import { AUTH_PATHS } from '../../data/http/auth-http.api';
import { LangStore } from '../lang.service';
import { TokenStore } from '../token-store';

/** Заголовки ставятся ТОЛЬКО на наш бэкенд: на тайлах Яндекса чужой Authorization ломает запрос. */
export const apiHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isApiRequest(req.url)) {
    return next(req);
  }

  // untracked: запрос может уйти из реактивного контекста — язык и токен не должны стать его зависимостями.
  const headers: Record<string, string> = { 'Accept-Language': untracked(inject(LangStore).lang) };
  const token = untracked(inject(TokenStore).accessToken);
  // У refresh своя семантика: чужой протухший access ему только мешает.
  if (token !== null && !req.url.startsWith(AUTH_PATHS.refresh)) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return next(req.clone({ setHeaders: headers }));
};
